/*
 * @Description: 简报账号管理
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-04-16 16:07:24
 * @LastEditTime: 2020-04-24 16:42:52
 */

import React from 'react'

// @ts-ignore
import s from './style.css'
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classNames from 'classnames'

import qs from 'querystring'

import { 
  getBrandInfo,
   getIndustryInfo,
   updateBrandName,
   updateBrandWords,
   doChangeBrandInfo,
   getReportBrandV,
   doAddReportBrandV,
   doChangeReportBrandV,
   doDelReportBrandV,
   doChangeEmotionReportBrandV
} from '../../controller';
import Tag from '../../components/Tag/Tag';
import EditInput from './EditInput';
import AdminBackNav from '../adminBackNav/adminBackNav';
import BrandInput from '../../components/BrandInput/BrandInput';

const platformList=[
  {
    type:'all',
    class:'所有平台'
  },{
    type:'wx',
    class:'微信'
  },{
    type:'wb',
    class:'微博'
  },{
    type:'zh',
    class:'知乎'
  },{
    type:'tt',
    class:'头条'
  },{
    type:'qeh',
    class:'企鹅号'
  },{
    type:'shh',
    class:'搜狐号'
  },{
    type:'wyh',
    class:'网易号'
  },{
    type:'ydh',
    class:'一点号'
  },{
    type:'bjh',
    class:'百家号'
  },{
    type:'xlkdh',
    class:'新浪看点号'
  },{
    type:'dfh',
    class:'大风号'
  },{
    type:'xqh',
    class:'雪球号'
  },{
    type:'pph',
    class:'澎湃号'
  }
]

class Briefing extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      beginTime: '',
      endTime: '',
      platform: 'all',
      industry: '',
      charts: 'db',
      files: null,
      treePos: {
        index: 0,
        zIndex: 0
      },
      // 编辑状态
      isEdit: false,
      brand: '',
      id: '',
      brandName: '',
      // 行业树切换时记录当前行业id
      industryId: '',
      industryName: '',
      industryList: [],
      treeDate: {},
      word: {
        eliminateWord: [],
        denyWords: [],
        markWords: [],
        seaWord: []
      },
      industryAttr: {
        industry: [],
        industryElimate: [],
        industryMark: []
      },
      officialAccount: [],
      accountPlatform: 'wx',
      newAccountPane: false,
      accountObject: {
        id: null,
        name: '',
        key: '',
        platform: 'wx'
      }
    }

    this.getBrandData = this.getBrandData.bind(this)
    this.editBrandName = this.editBrandName.bind(this)
    this.updateBrandWords = this.updateBrandWords.bind(this)
    this.editKeyWord = this.editKeyWord.bind(this)
    this.deleteKeyWord = this.deleteKeyWord.bind(this)
    this.change = this.change.bind(this)
    this.exportExcel = this.exportExcel.bind(this)
    this.fileChange = this.fileChange.bind(this)
    this.upload = this.upload.bind(this)
  }

  /**
   * 获取企业信息
   * @param {String} name 
   */
  getBrandData (name) {
    getBrandInfo({ brandName: name })
      .then(res => {
        this.setState({
          ...res,
        })
      })
  }

  /**
   * 获取行业信息
   * @param {Object} param0 
   */
  getIndustryInfo ({ brandName, areaIndustry }) {
    getIndustryInfo({
      brandName,
      areaIndustry
    })
      .then(res => {
        this.setState({
          industryAttr: {
            industry: res.industry || [],
            industryElimate: res.industryElimate || [],
            industryMark: res.industryMark || []
          }
        })
        console.log(res);
      })
  }

  /**
   * 行业树点击事件
   * @param {*} event 
   * @param {*} param1 
   */
  treeClickHandle (event, {zIndex, index, value, id}) {

    const brandName = this.state.brandName
    
    if (zIndex !== 0) {
      this.getIndustryInfo({
        brandName,
        areaIndustry: value
      })
    }

    this.setState({
      treePos: {
        index,
        zIndex
      },
      industryId: id,
      industryName: value
    })
  }


  /**
   * 修改品牌名称
   * @param {String} name 
   */
  editBrandName (name) {
    updateBrandName({
      brandName: name,
      brandId: this.state.id
    })
      .then(res => {
        if(res) {
          alert('修改成功')
          this.getBrandData(name)
        } else {
          alert('修改失败')
        }
      })
  }

  /**
   * 更新品牌关键词
   * @param {Object} params 
   */
  updateBrandWords (params) {
    updateBrandWords(params)
      .then(res => {
        if (res) {
          alert('成功')
          // 如果有行业id获取行业标签，否则获取品牌数据
          if (!params.industryId) {
            this.getBrandData(this.state.brandName)
          } else {
            if (this.state.brandName === this.state.industryName || !this.state.industryName) {
              this.getBrandData(this.state.brandName)
            } else {
              this.getIndustryInfo({
                brandName: this.state.brandName,
                areaIndustry: this.state.industryName
              })
            }
          }
        } else {
          alert('失败')
        }
      })
  }

  /**
   * 构造添加和删除行业参数，并调用接口
   * @param {String} info 
   * @param {String} key 
   * @param {String} arithmetic 
   * @param {Boolean} industryId 
   */
  editKeyWord (info, key, arithmetic, industryId = false) {
    const params = {
      info,
      key,
      arithmetic,
      brandId: this.state.id
    }
    if (industryId) {
      params['industryId'] = this.state.industryId
    }
    
    this.updateBrandWords(params)
  }

  
  deleteKeyWord (name, key) {
    const  params = {
      info: name,
      brandId: this.state.id,
      industryId: this.state.industryId || this.state.id,
      arithmetic: 'delete',
      key: key
    }

    if (this.state.isEdit) {
      const isDelete = confirm('确定删除该标签？')
      if (isDelete) this.updateBrandWords(params)
    }
  }

  /**
   * 行业树列表
   * 递归调用
   * @param {Array} list 
   * @param {Number} zIndex 
   */
  renderTree (list, zIndex = 0) {
    const treePos = this.state.treePos

    
    return (
      <ul>
        {list.map((item, index) => (
          <li className={s.treeNode} key={index}>
            <p className={
                classNames(s.treeTitle, {
                  [s.treeTitleActive]: (treePos.zIndex === zIndex && treePos.index === index)
                })
              } 
              onClick={(e) => {
                this.treeClickHandle(e, {
                  zIndex,
                  index,
                  value: item.name,
                  id: item.id
                })
              }}>{item.name}</p>
            {item.children ? this.renderTree(item.children, zIndex + 1) : null}
          </li>
        ))}
      </ul>
    )
  }

  /**
   * 品牌详情-tag列表
   * @param {Array|String} list 
   */
  renderTag (list, key = '') {
    const _list = list || []
    return (
      <div>
        {
          (typeof _list === 'string')
           ? <span>{_list}</span>
           : _list.map((item, index) => (
              <Tag className={s.tag} key={index} onClick={e => {this.deleteKeyWord(item, key)}}>{item}</Tag>
            )) 
        }
      </div>
    )
  }

  /**
   * input 改变
   * @param {*} e 
   */
  fileChange (e) {
    const files = e.target.files
    console.log(files);
    
    this.setState({
      files: files
    })
  }

  /**
   * 上传文件
   */
  upload () {
    const id = this.state.id
    if (!id) {
      return alert('请选择品牌')
    }

    let formData=new FormData()
    formData.append('filedata', this.state.files[0])

    doChangeBrandInfo(formData, this.state.id)
      .then(res => {
        console.log(res);
      })
  }

  /**
   * 品牌标签列表
   */
  renderBrandTagList () {
    const {word, isEdit} = this.state
    return (
      <div className={s.treeRender}>
        <div className={s.classify}>
          <label className={s.label}>搜索关键词：</label>
          {this.renderTag(word.seaWord, 'nickName')}
          {isEdit ? <EditInput onClick={name => this.editKeyWord(name, 'nickName', 'add')} /> : null}
        </div>
        <div className={s.classify}>
          <label className={s.label}>排除关键词：</label>
          {this.renderTag(word.eliminateWord, 'eliminateWords')}
          {isEdit ? <EditInput onClick={name => this.editKeyWord(name, 'eliminateWords', 'add')} /> : null}
        </div>
        <div className={s.classify}>
          <label className={s.label}>否定关键词：</label>
          {this.renderTag(word.denyWords, 'denyWords')}
          {isEdit ? <EditInput onClick={name => this.editKeyWord(name, 'denyWords', 'add')} /> : null}
        </div>
        <div className={s.classify}>
          <label className={s.label}>打标签关键词：</label>
          {this.renderTag(word.markWords, 'markWords')}
          {isEdit ? <EditInput onClick={name => this.editKeyWord(name, 'markWords', 'add')} /> : null}
        </div>
      </div>
    )
  }

  /**
   * 行业标签列表
   */
  renderIndustryTagList () {
    const {industryAttr, isEdit} = this.state

    return (
      <div className={s.treeRender}>
        <div className={s.classify}>
          <label className={s.label}>行业：</label>
          {this.renderTag(industryAttr.industry)}
        </div>
        <div className={s.classify}>
          <label className={s.label}>行业标签关键词：</label>
          {this.renderTag(industryAttr.industryMark, 'industryKey')}
          {isEdit ? <EditInput onClick={name => this.editKeyWord(name, 'industryKey', 'add', true)} /> : null}
        </div>
        <div className={s.classify}>
          <label className={s.label}>行业排除关键词：</label>
          {this.renderTag(industryAttr.industryElimate, 'eliminateWordsToIndustry')}
          {isEdit ? <EditInput onClick={name => this.editKeyWord(name, 'eliminateWordsToIndustry', 'add', true)} /> : null}
        </div>
      </div>
    )
  }

  /**
   * 品牌详情
   */
  renderBrand () {
    const {id, brandName, treeDate, isEdit} = this.state

    return (
      <div className={s.brandWrapper}>
        <hr/>
        <div className={s.item}>
          <label className={s.label}>品牌ID：</label>
          <span>{id}</span>
        </div>
        <div className={s.item}>
          <label className={s.label}>品牌名称：</label>
          <span>{brandName}</span>
          {isEdit ? <EditInput onClick={this.editBrandName} /> : null}
        </div>
        <div className={s.item}>
          <label className={s.label}>行业树：</label>
          <div className={s.treeWrapper}>
            <div className={s.treeBox}>
              {this.renderTree([treeDate])}
            </div>
            {this.state.treePos.zIndex === 0 ? this.renderBrandTagList() : this.renderIndustryTagList()}
          </div>
        </div>

        <div className={s.item}>
          <label className={s.label}>品牌原LOGO：</label>
          <img src={`/digitalAssets/resources/img/LOGO/${id}.png`} alt={brandName}/>
        </div>
        {isEdit ? 
          <div className={s.item}>
            <label className={s.label}>新LOGO：</label>
            <input type="file" onChange={this.fileChange} />
            <button type="button" onClick={this.upload}>上传LOGO</button>
            {/* <span onClick={this.openUpload.bind(this)} className={s.addTure}>
                    上传logo
                  </span> */}
          </div>
          : null}
      </div>
    )
  }

  change (key, value) {
    this.setState({
      [key]: value
    })
  }

  /**
   * 导出文件
   */
  exportExcel () {
    const {brandName, beginTime, endTime, platform, charts, industry} = this.state;

    const params = {
        brandName: brandName,
        timeStart: beginTime,
        timeEnd: endTime,
        platform: platform,
        charts: charts
    };
    if (industry) {
      params.industry = industry
    }

    const begin = params.timeStart.split('-').join('');
    const end = params.timeEnd.split('-').join('');

    if (begin > end) {
      return alert('开始时间不能小于结束时间！')
    } else if (params.brandName === '') {
      return alert('请填写上方品牌名称！')
    }


    const url = `/dbrankCMS/saveBrandChartsData?${qs.stringify(params)}`
    console.log(url);

    window.open(url, "_blank")
  }
  
  renderEditBtnGroup () {
    return (
      <div className={s.btnGroup}>
        <button type="button" className={classNames(s.btn, s.danger)} onClick={e => this.setState({isEdit: true})}>编辑</button>
        <button type="button" className={s.btn} onClick={e => this.setState({isEdit: false})}>取消</button>
      </div>
    )
  }

  /**
   * 获取官方账号
   *
   * @memberof Brand
   */
  getReportBrandV = () => {
    const brand = this.state.brandName
    if (!brand) return alert('请输入品牌')

    getReportBrandV({
      brandName: this.state.brandName,
      platform: this.state.accountPlatform
    })
      .then(res => {
        if (res) {
          this.setState({
            officialAccount: res
          })
        }
      })
  }

  addAccount = () => {
    this.setState({
      newAccountPane: true,
      accountObject: {
        id: null,
        name: '',
        key: '',
        platform: 'wx'
      }
    })
  }

  /**
   * 打开编辑面板
   *
   * @memberof Brand
   */
  editAccount = (item) => {
    this.setState({
      newAccountPane: true,
      accountObject: {
        id: item.id,
        name: item.vName,
        key: item.key,
        platform: item.platform
      }
    })
  }

  /**
   * 关闭新增窗口
   *
   * @memberof Brand
   */
  cancelAccount = () => {
    this.setState({
      newAccountPane: false,
      accountObject: {
        id: null,
        name: '',
        key: '',
        platform: 'wx'
      }
    })
  }

  /**
   * 新增官方账号
   * @memberof Brand
   */
  addAccountAction = (query) => {
    doAddReportBrandV(query)
      .then(res => {
        if(res.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
        }
        this.cancelAccount()
      })
  }


  /**
   * 修改官方账号
   * @memberof Brand
   */
  editAccountAction = (query) => {
    doChangeReportBrandV(query)
      .then(res => {
        if(res && res.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
        }
        this.cancelAccount()
      })
  }


  /**
   * 提交修改|新增账号
   * @memberof Brand
   */
  submitAccount = () => {
    const {accountObject, brandName} = this.state

    const query = {
      brandName: brandName,
      platform: accountObject.platform,
      vName: accountObject.name,
      key: accountObject.key
    }

    if (accountObject.id) {
      query.id = accountObject.id
      this.editAccountAction(query)
    } else {
      this.addAccountAction(query)
    }
  }

  /**
   * 新增|修改账号属性
   * @memberof Brand
   */
  accountChange = (name, value) => {
    const accountObject = this.state.accountObject
    this.setState({
      accountObject: {
        ...accountObject,
        [name]: value
      }
    })
  }

  /**
   * 删除官方账号
   *
   * @memberof Brand
   */
  delAccountAction = (item) => {
    const status = confirm(`确定删除 官方名称为 ${item.vName} 的账号？`)

    if (!status) return false

    doDelReportBrandV({
      id: item.id
    })
      .then(res => {
        if(res.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
        }
      })
  }

  /**
   * 批量修改该帐号情感倾向
   *
   * @memberof Brand
   */
  batchEditEmotionAction = (item) => {
    const status = confirm(`确定批量修改 官方名称为 ${item.vName} 的账号 情感倾向？`)
    const {brandName} = this.state
    if (!status) return false

    doChangeEmotionReportBrandV({
      brandName: brandName,
      key: item.key,
      platform: item.platform
    })
      .then(res => {
        if(res.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
        }
      })
  }


  render () {
    const {industryList, id} = this.state

    return (
      <div className={s.container}>
        <AdminBackNav />

        <h1>简报账号管理</h1>

        <div className={s.wrapper}>
          {id ? this.renderEditBtnGroup() : null}
          
          {id ? this.renderBrand() : null}

          <div style={{display: 'flex'}}>
            
            <div className={s.item}>
              <label className={s.label}>查询品牌：</label>
              <BrandInput value={this.state.brandName} onChange={this.getBrandData} className={s.input} />
              {this.state.brandName}
            </div>
            <div className={s.item}>
              <label className={s.label}>选择平台：</label>
              <select className={s.input} value={this.state.accountPlatform} onChange={(e) => this.setState({accountPlatform: e.target.value})}>
                {platformList.map(item => <option value={item.type} key={item.type}>{item.class}</option>)}
                <option value="wk">悟空问答</option>
              </select>
            </div>

            <hr/>

            <div className={s.btnWrapper}>
              <button className={s.btn} type="button" onClick={this.getReportBrandV}>查询</button>
              <button className={s.btn} type="button" onClick={this.addAccount}>新建</button>
            </div>
          </div>
          <div className={s.tableWrapper}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>id</th>
                  <th>账号名称</th>
                  <th>key</th>
                  <th>平台</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                {this.state.officialAccount.map((item, index) => (
                  <tr key={index}>
                    <td>{item.vName}</td>
                    <td>{item.vName}</td>
                    <td>{item.key}</td>
                    <td>{item.platform}</td>
                    <td>
                      {/* <span style={{cursor:'pointer'}}onClick={()=>{ this.batchEditEmotionAction(item) }}>批量中立</span>
                      / */}
                      <span style={{cursor:'pointer'}} onClick={()=> this.editAccount(item)}>修改</span>
                      /
                      <span onClick={()=>{this.delAccountAction(item)}} style={{cursor:'pointer',color:'red'}}>删除</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>


            {this.state.newAccountPane && 
            <div className={s.newAccount}>
              {this.state.accountObject.id &&
              <div className={s.item}>
                <label className={s.label}>官网名称：</label>
                {this.state.accountObject.id}
              </div>
              }
              
              <div className={s.item}>
                <label className={s.label}>官网名称：</label>
                <input className={s.input} value={this.state.accountObject.name} onChange={e => this.accountChange('name', e.target.value)} />
              </div>

              <div className={s.item}>
                <label className={s.label}>key：</label>
                <input className={s.input} value={this.state.accountObject.key}  onChange={e => this.accountChange('key', e.target.value)} />
              </div>

              <div className={s.item}>
                <label className={s.label}>选择平台：</label>
                <select className={s.input} value={this.state.accountObject.platform} onChange={e => this.accountChange('platform', e.target.value)}>
                {platformList.map(item => <option value={item.type} key={item.type}>{item.class}</option>)}

                  {/* <option value="wx">微信</option>
                  <option value="wb">微博</option>
                  <option value="zh">知乎</option>
                  <option value="tt">头条</option>
                  <option value="wk">悟空问答</option> */}
                </select>
              </div>

              <div className={s.btnWrapper}>
                <button className={s.btn} type="button" onClick={this.submitAccount}>提交</button>
                <button className={s.btn} type="button" onClick={this.cancelAccount}>取消</button>
              </div>
            </div>
            }
          
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(Briefing)



// WEBPACK FOOTER //
// src/routes/cms/Briefing.js